import React, { Component } from 'react';
import { Route, Routes, Navigate, useLocation, useNavigate, useParams } from 'react-router-dom';

//Views
import UserLogin from './views/feature/authentication/userLogin';
import Equipments from './views/feature/equipments/index.jsx';
import Shoots from './views/feature/shoots/index.jsx';
import Shoot from './views/feature/shoots/shoot.jsx';
import TenantUsers from './views/feature/tenantUsers';
import MemoryCard from './views/feature/MemoryCard';
import EquipmentsOverview from './views/feature/EquipmentsOverview';
import AssignEquipment from './views/feature/shoots/asssignEquipment';
import ReceiveEquipment from './views/feature/shoots/receiveEquipment';
import AsssignMemoryCards from './views/feature/shoots/asssignMemoryCards';
import ReceiveMemoryCards from './views/feature/shoots/receiveMemoryCards';
import ProjectDetails from './views/feature/shoots/projectDetails';
import RemapEquipment from './views/feature/adminTools/remampEquipment';
import RemapMemoryCard from './views/feature/adminTools/remapMemoryCard';
import AdminLayout from './views/layouts/admin';
import RegisterMemoryCard from './views/feature/adminTools/registerMemoryCard';
import RegisterEquipments from './views/feature/adminTools/registerEquipments';
import ShootsOverview from './views/feature/shootsOverview';
import Projects from './views/feature/Projects';
import ShootsTenantUsers from './views/feature/shootsOverview/shootsTenantsOverview';
import HuemnChat from './views/feature/huemnChat';
import VendorUsers from './views/feature/adminTools/vendorUsers';
import MonthlyOverviewGraph from './views/feature/monthlyOverviewGraph';
import CrewPlanner from './views/feature/crewPlanner';

//Layouts
import PublicLayout from './views/layouts/public';
import Layout from './views/layouts';

import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import Schema from './schema';
import HardDrives from './views/feature/HardDrives';
import AssignHardDrives from './views/feature/HardDrives/AssignHardDrives';
import ReceiveHardDrives from './views/feature/HardDrives/ReceiveHardDrives';
import MemoryCardLogs from './views/feature/MemoryCard/MemoryCardLogs';
import EquipmentLogs from './views/feature/equipments/EquipmentLogs';
import NewShoot from './views/feature/shoots/NewShoot';
import HardDriveLogs from './views/feature/HardDrives/HardDriveLogs';
import HardDriveScanDetails from './views/feature/HardDrives/HardDriveScanDetails';
import HrEmployeeModule from './views/feature/HrEmployeeModule';
import EmployeeDetails from './views/feature/HrEmployeeModule/EmployeeDetails';
import AddEmployee from './views/feature/HrEmployeeModule/AddEmployee';
import EditEmployee from './views/feature/HrEmployeeModule/EditEmployee';
import RegisterAssets from './views/feature/adminTools/registerAssets';
import Assets from './views/feature/assets';
import AssetsMemoryCards from './views/feature/assets/memoryCards';

import AssetsEquipments from './views/feature/assets/equipments';
import RemapAsset from './views/feature/adminTools/remapAsset';
import CreateDeliverable from './views/feature/Deliverables/CreateDeliverable';
import Deliverables from './views/feature/Deliverables/Deliverables';
import ProjectsOverviewPage from './views/feature/Projects/ProjectsOverview/ProjectsOverviewPage';
import Tasks from './views/feature/tasks';
import Attendance from './views/feature/attendance/index.jsx';
import EmployeeAttendanceDetails from './views/feature/attendance/EmployeeAttendanceDetails.jsx';
import AttendanceFormatTable from './views/components/AttendanceFormatTable.jsx';
// import MemoryCardLogs from './views/feature/shoots/MemoryCardLogs';

class App extends Component {
	render() {
		return (
			<>
				<Routes>
					<Route exact path="/" element={<Navigate to="/user/login" />}></Route>
					<Route exact path="/graphql-schema" element={<Schema />}></Route>
					<Route
						exact
						path="/user/login"
						element={
							<PublicLayout subTitle={'Log in to your workspace'}>
								<UserLogin
									router={{
										useLocation,
										useNavigate,
										useParams,
									}}
								/>
							</PublicLayout>
						}
					/>
					<Route exact path="/huemn-chat" element={<HuemnChat />} />
					{/* <Route
						exact
						path="/:vendorID/equipments-overview"
						element={
							<Layout
								router={{
									useLocation,
									useNavigate,
									useParams,
								}}
							>
								<EquipmentsOverview />
							</Layout>
						}
					/> */}
					<Route
						exact
						path="/:vendorID/equipments"
						element={
							<Layout
								router={{
									useLocation,
									useNavigate,
									useParams,
								}}
							>
								<Equipments />
							</Layout>
						}
					/>
					<Route
						exact
						path="/:vendorID/shoots"
						element={
							<Layout
								router={{
									useLocation,
									useNavigate,
									useParams,
								}}
							>
								<Shoots />
							</Layout>
						}
					/>
					<Route
						exact
						path="/:vendorID/harddrives"
						element={
							<Layout
								router={{
									useLocation,
									useNavigate,
									useParams,
								}}
							>
								<HardDrives />
							</Layout>
						}
					/>
					<Route
						exact
						path="/:vendorID/hr"
						element={
							<Layout
								router={{
									useLocation,
									useNavigate,
									useParams,
								}}
							>
								<HrEmployeeModule />
							</Layout>
						}
					/>
					<Route
						exact
						path="/:vendorID/hr/add-employee"
						element={
							<Layout
								router={{
									useLocation,
									useNavigate,
									useParams,
								}}
							>
								<AddEmployee />
							</Layout>
						}
					/>
					<Route
						exact
						path="/:vendorID/hr/:employeeId"
						element={
							<Layout
								router={{
									useLocation,
									useNavigate,
									useParams,
								}}
							>
								<EmployeeDetails />
							</Layout>
						}
					/>
					<Route
						exact
						path="/:vendorID/hr/:employeeId/edit-employee"
						element={
							<Layout
								router={{
									useLocation,
									useNavigate,
									useParams,
								}}
							>
								<EditEmployee />
							</Layout>
						}
					/>
					<Route
						exact
						path="/:vendorID/shoots-tenant-users"
						element={
							<Layout
								router={{
									useLocation,
									useNavigate,
									useParams,
								}}
							>
								<ShootsTenantUsers />
							</Layout>
						}
					/>
					<Route
						exact
						path="/:vendorID/monthly-overview-graph"
						element={
							<Layout
								router={{
									useLocation,
									useNavigate,
									useParams,
								}}
							>
								<MonthlyOverviewGraph />
							</Layout>
						}
					/>
					<Route
						exact
						path="/:vendorID/shoots-overview"
						element={
							<Layout
								router={{
									useLocation,
									useNavigate,
									useParams,
								}}
							>
								<ShootsOverview />
							</Layout>
						}
					/>
					<Route
						exact
						path="/:vendorID/shoots/:workspaceID/:projectID"
						element={
							<Layout
								router={{
									useLocation,
									useNavigate,
									useParams,
								}}
							>
								<ProjectDetails />
							</Layout>
						}
					/>
					<Route
						exact
						path="/:vendorID/projects-overview/:workspaceID/:projectID"
						element={
							<Layout
								router={{
									useLocation,
									useNavigate,
									useParams,
								}}
							>
								<ProjectsOverviewPage />
							</Layout>
						}
					/>

					<Route
						exact
						path="/:vendorID/harddrives/assign"
						element={
							<Layout
								router={{
									useLocation,
									useNavigate,
									useParams,
								}}
							>
								<AssignHardDrives />
							</Layout>
						}
					/>
					<Route
						exact
						path="/:vendorID/harddrives/receive"
						element={
							<Layout
								router={{
									useLocation,
									useNavigate,
									useParams,
								}}
							>
								<ReceiveHardDrives />
							</Layout>
						}
					/>
					{/* <Route
						exact
						path="/:vendorID/shoots/:workspaceID/:projectID/:shootID"
						element={
							<Layout
								router={{
									useLocation,
									useNavigate,
									useParams,
								}}
							>
								<Shoot />
							</Layout>
						}
					/> */}
					<Route
						exact
						path="/:vendorID/shoots/:workspaceID/:projectID/:shootID"
						element={
							<Layout
								router={{
									useLocation,
									useNavigate,
									useParams,
								}}
							>
								<NewShoot />
							</Layout>
						}
					/>
					<Route
						exact
						path="/:vendorID/shoots/:workspaceID/:projectID/:shootID/assign-equipment"
						element={
							<Layout
								router={{
									useLocation,
									useNavigate,
									useParams,
								}}
							>
								<AssignEquipment />
							</Layout>
						}
					/>
					<Route
						exact
						path="/:vendorID/shoots/:workspaceID/:projectID/:shootID/receive-equipment"
						element={
							<Layout
								router={{
									useLocation,
									useNavigate,
									useParams,
								}}
							>
								<ReceiveEquipment />
							</Layout>
						}
					/>
					<Route
						exact
						path="/:vendorID/shoots/:workspaceID/:projectID/:shootID/assign-memory-card"
						element={
							<Layout
								router={{
									useLocation,
									useNavigate,
									useParams,
								}}
							>
								<AsssignMemoryCards />
							</Layout>
						}
					/>
					<Route
						exact
						path="/:vendorID/shoots/:workspaceID/:projectID/:shootID/receive-memory-card"
						element={
							<Layout
								router={{
									useLocation,
									useNavigate,
									useParams,
								}}
							>
								<ReceiveMemoryCards />
							</Layout>
						}
					/>
					<Route
						exact
						path="/:vendorID/tenant-users"
						element={
							<Layout
								router={{
									useLocation,
									useNavigate,
									useParams,
								}}
							>
								<TenantUsers />
							</Layout>
						}
					/>
					<Route
						exact
						path="/:vendorID/admin-tools/register-equipments"
						element={
							<Layout
								router={{
									useLocation,
									useNavigate,
									useParams,
								}}
							>
								<AdminLayout>
									<RegisterEquipments />
								</AdminLayout>
							</Layout>
						}
					/>
					<Route
						exact
						path="/:vendorID/admin-tools/vendor-users"
						element={
							<Layout
								router={{
									useLocation,
									useNavigate,
									useParams,
								}}
							>
								<AdminLayout>
									<VendorUsers />
								</AdminLayout>
							</Layout>
						}
					/>
					<Route
						exact
						path="/:vendorID/admin-tools/register-memory-card"
						element={
							<Layout
								router={{
									useLocation,
									useNavigate,
									useParams,
								}}
							>
								<AdminLayout>
									<RegisterMemoryCard />
								</AdminLayout>
							</Layout>
						}
					/>
					<Route
						exact
						path="/:vendorID/admin-tools/register-assets"
						element={
							<Layout
								router={{
									useLocation,
									useNavigate,
									useParams,
								}}
							>
								<AdminLayout>
									<RegisterAssets />
								</AdminLayout>
							</Layout>
						}
					/>
					<Route
						exact
						path="/:vendorID/admin-tools/remap-memorycard"
						element={
							<Layout
								router={{
									useLocation,
									useNavigate,
									useParams,
								}}
							>
								<AdminLayout>
									<RemapMemoryCard />
								</AdminLayout>
							</Layout>
						}
					/>
					<Route
						exact
						path="/:vendorID/admin-tools/remap-asset"
						element={
							<Layout
								router={{
									useLocation,
									useNavigate,
									useParams,
								}}
							>
								<AdminLayout>
									<RemapAsset />
								</AdminLayout>
							</Layout>
						}
					/>
					<Route
						exact
						path="/:vendorID/admin-tools/remap-equipment"
						element={
							<Layout
								router={{
									useLocation,
									useNavigate,
									useParams,
								}}
							>
								<AdminLayout>
									<RemapEquipment />
								</AdminLayout>
							</Layout>
						}
					/>
					<Route
						exact
						path="/:vendorID/memory-cards"
						element={
							<Layout
								router={{
									useLocation,
									useNavigate,
									useParams,
								}}
							>
								<MemoryCard />
							</Layout>
						}
					/>
					<Route
						exact
						path="/:vendorID/memory-cards/:qrcode"
						element={
							<Layout
								router={{
									useLocation,
									useNavigate,
									useParams,
								}}
							>
								<MemoryCardLogs />
							</Layout>
						}
					/>
					{/* equipments */}
					<Route
						exact
						path="/:vendorID/equipments/:qrcode"
						element={
							<Layout
								router={{
									useLocation,
									useNavigate,
									useParams,
								}}
							>
								<EquipmentLogs />
							</Layout>
						}
					/>
					<Route
						exact
						path="/:vendorID/harddrives/:qrCode"
						element={
							<Layout
								router={{
									useLocation,
									useNavigate,
									useParams,
								}}
							>
								<HardDriveLogs />
							</Layout>
						}
					/>
					<Route
						exact
						path="/:vendorID/harddrives/scan"
						element={
							<Layout
								router={{
									useLocation,
									useNavigate,
									useParams,
								}}
							>
								<HardDriveScanDetails />
							</Layout>
						}
					/>
					<Route
						exact
						path="/:vendorID/projects"
						element={
							<Layout
								router={{
									useLocation,
									useNavigate,
									useParams,
								}}
							>
								<Projects />
							</Layout>
						}
					/>
					<Route
						exact
						path="/:vendorID/tasks"
						element={
							<Layout
								router={{
									useLocation,
									useNavigate,
									useParams,
								}}
							>
								<Tasks />
							</Layout>
						}
					/>
					<Route
						exact
						path="/:vendorID/attendance"
						element={
							<Layout
								router={{
									useLocation,
									useNavigate,
									useParams,
								}}
							>
								<Attendance />
							</Layout>
						}
					/>
					<Route
						exact
						path="/:vendorID/attendance/:attendanceid"
						element={
							<Layout
								router={{
									useLocation,
									useNavigate,
									useParams,
								}}
							>
								<EmployeeAttendanceDetails />
							</Layout>
						}
					/>

					<Route
						exact
						path="/:vendorID/deliverables/:workspaceID/:projectID"
						element={
							<Layout
								router={{
									useLocation,
									useNavigate,
									useParams,
								}}
							>
								<CreateDeliverable />
							</Layout>
						}
					/>
					<Route
						exact
						path="/:vendorID/deliverables"
						element={
							<Layout
								router={{
									useLocation,
									useNavigate,
									useParams,
								}}
							>
								<Deliverables />
							</Layout>
						}
					/>
					<Route
						exact
						path="/:vendorID/assets"
						element={
							<Layout
								router={{
									useLocation,
									useNavigate,
									useParams,
								}}
							>
								<Assets />
							</Layout>
						}
					/>
					<Route
						exact
						path="/:vendorID/assets/memory-cards"
						element={
							<Layout
								router={{
									useLocation,
									useNavigate,
									useParams,
								}}
							>
								<AssetsMemoryCards />
							</Layout>
						}
					/>
					<Route
						exact
						path="/:vendorID/assets/equipments"
						element={
							<Layout
								router={{
									useLocation,
									useNavigate,
									useParams,
								}}
							>
								<AssetsEquipments />
							</Layout>
						}
					/>
					<Route
						exact
						path="/:vendorID/crew-planner"
						element={
							<Layout
								router={{
									useLocation,
									useNavigate,
									useParams,
								}}
							>
								<CrewPlanner />
							</Layout>
						}
					/>
				</Routes>

				<ToastContainer
					position="top-right"
					autoClose={5000}
					hideProgressBar
					newestOnTop
					closeOnClick
					rtl={false}
					pauseOnFocusLoss
					draggable
					pauseOnHover
				/>
			</>
		);
	}
}

export default App;
